const camelCase = (str: string) => {
	return str.replace(/( |-)./g, (match) => {
		return match.replace(' ', '').replace('-', '').toUpperCase();
	});
};

export const normalizeSourceName = (...parts: string[]): string => {
	return parts
		.filter(Boolean)
		.map((part, index) => {
			const trimmedPart = part.trimLeft();
			if (index === 0) {
				return trimmedPart[0].toLowerCase() + camelCase(trimmedPart.slice(1));
			}

			return trimmedPart[0].toUpperCase() + camelCase(trimmedPart.slice(1).toLowerCase());
		})
		.join('');
};

/**
 * Calculates the scroll depth of the current page
 * @returns Number between 0 and 1 representing scroll progress
 */
export const calculateScrollDepth = (): number => {
	const windowHeight = window.innerHeight;
	const documentHeight = document.documentElement.scrollHeight;
	const scrollTop = window.scrollY || document.documentElement.scrollTop;

	if (documentHeight === 0) {
		return 0;
	}

	const depth = (scrollTop + windowHeight) / documentHeight;
	return Math.min(Math.max(depth, 0), 1); // Clamp between 0 and 1
};

/**
 * Factory function that returns an analytics client.
 * Purely some sugar to make testing easier.
 */
export const createAnalyticsClient = (options: {
	version: string;
	product: string;
	env: string;
	locale: string;
	useLegacyUrl: boolean;
}): any => {
	// We require this so it's lazily instantiated (doesn't run on SSR!)
	const AnalyticsWebClient = require('@atlassiansox/analytics-web-client/client').default;
	const { useLegacyUrl, ...opts } = options;
	// See repo for setup instructions:
	// https://bitbucket.org/atlassian/analytics-web-client/src/master/
	return new AnalyticsWebClient(opts, { useLegacyUrl });
};
